// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import ExportIcon from '@mui/icons-material/Description'
import InfoIcon from '@mui/icons-material/Info'
import { Button, Tooltip, Typography } from '@mui/material'
import moment from 'moment'
import React from 'react'
import { Mutation } from 'react-apollo'
import { Link } from 'react-router-dom'
import { downloadExcelFromBase64 } from '../../common/utils'
import type { Reservation } from '../dailyInfo/data'
import { i18n } from '../index/index'
import { Widget, WidgetHeader } from './OldDashboardComponents'
import { exportReservations } from './oldDashboardQueries'
import css from './oldReservations.css'
type Props = {
  rows: Array<Reservation>
  date: string
  stationId: ID
}

const reservationTypeLabelMap = {
  // Other type is populated with an empty string.
  '': 'dailyInfo.reservationsTable.otherTypeLabel',
  buffet: 'dailyInfo.reservationsTable.buffetTypeLabel',
  PizzaTable: 'dailyInfo.reservationsTable.pizzaTableTypeLabel',
  BuffetWorld: 'dailyInfo.reservationsTable.buffetWorldTypeLabel',
}

const Reservations = ({ rows, stationId, date }: Props) => {
  const downloadFile = (data) => {
    const file_date = moment(date).format('DD_MM_YYYY')
    const fileName = `VARAUKSET_${file_date}.xlsx`
    downloadExcelFromBase64(fileName, data.exportReservations)
  }

  const hasReservations = Array.isArray(rows) && rows.length > 0

  return (
    <Widget>
      <div className={css.headerRow}>
        <WidgetHeader>{i18n.t('dailyInfo.reservationsTable.tableTitle')}</WidgetHeader>
        <Link className={css.exportLink} to={`/ravintolainfo`}>
          <Button variant='contained'>{i18n.t('dailyInfo.reservationsTable.addReservation')}</Button>
        </Link>
      </div>

      {!hasReservations ? (
        <div className={css.emptyState}>
          <Typography className={css.emptyStateText}>{i18n.t('dailyInfo.reservationsTable.noReservations')}</Typography>
        </div>
      ) : (
        <div>
          <div className={css.widgetContent}>
            <table className={css.table}>
              <thead>
                <tr>
                  <th>{i18n.t('dailyInfo.reservationsTable.dayOfWeek')}</th>
                  <th>{i18n.t('dailyInfo.reservationsTable.date')}</th>
                  <th>{i18n.t('dailyInfo.reservationsTable.startTimeTableHeader')}</th>
                  <th>{i18n.t('dailyInfo.reservationsTable.endTimeTableHeader')}</th>
                  <th>{i18n.t('dailyInfo.reservationsTable.roomTableHeader')}</th>
                  <th>{i18n.t('dailyInfo.reservationsTable.groupNameTableHeader')}</th>
                  <th>{i18n.t('dailyInfo.reservationsTable.type')}</th>
                  <th>{i18n.t('dailyInfo.reservationsTable.groupSizeTableHeader')}</th>
                  <th>{i18n.t('dailyInfo.reservationsTable.contactNameLabel')}</th>
                  <th>{i18n.t('dailyInfo.reservationsTable.contactPhoneLabel')}</th>
                  <th>{i18n.t('dailyInfo.reservationsTable.paymentMethodLabel')}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {rows.map((reservation: Reservation, i: number) => {
                  const reservationTime = moment(new Date(reservation.startTime))
                  return (
                    <tr key={i}>
                      <td>{reservationTime.format('dd')}</td>
                      <td>{reservationTime.format('D.M.YYYY')}</td>
                      <td>{reservationTime.format('HH:mm')}</td>
                      <td>{reservation.endTime || '-'}</td>
                      <td>{reservation.room}</td>
                      <td>{reservation.name}</td>
                      <td>
                        {Object.keys(reservationTypeLabelMap).includes(reservation.reservationType)
                          ? i18n.t(reservationTypeLabelMap[reservation.reservationType])
                          : ''}
                      </td>
                      <td>{reservation.peopleCount}</td>
                      <td>{reservation.contactName}</td>
                      <td>{reservation.contactPhone}</td>
                      <td>{reservation.paymentMethod}</td>

                      <td className={css.linkCell}>
                        <Tooltip
                          placement='top-end'
                          enterTouchDelay={50}
                          leaveTouchDelay={10000}
                          title={
                            <Typography sx={{ fontSize: '1.25em' }}>
                              {reservation.otherInfo && (
                                <div>{`${i18n.t('dailyInfo.reservationsTable.otherInfo')}: ${reservation.otherInfo}`}</div>
                              )}
                              {reservation.mealOptionDescription && <div>{reservation.mealOptionDescription}</div>}
                            </Typography>
                          }
                        >
                          <div
                            style={{
                              width: 20,
                            }}
                          >
                            <InfoIcon className={css.actionIcon} />
                          </div>
                        </Tooltip>

                        <Link className={css.exportLink} to={`/ravintolainfo/${reservationTime.format('YYYY-MM-DD')}`}>
                          <ExportIcon className={css.actionIcon} />
                        </Link>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
          <Mutation
            mutation={exportReservations}
            variables={{ stationId, date }}
            onCompleted={(data) => downloadFile(data)}
          >
            {(onMutate) => (
              <div className={css.exportButtonContainer}>
                <Button variant='contained' onClick={onMutate}>
                  {i18n.t('reporting.label.feelingMeterNotes.export')}
                </Button>
              </div>
            )}
          </Mutation>
        </div>
      )}
    </Widget>
  )
}

export default Reservations
